<template>
  <b-card
    no-body
    class="p-3 h-100 rounded-0"
    :class="businessCardStyle">
    <div class="d-flex flex-row">
      <div class="mr-3 h-100 mb-3">
        <slot name="bcImage">
          <div class="circle rounded-circle">
            <img
              :class="{'rounded-circle' : imageSrc, 'default-avatar' : !imageSrc}"
              :height="businessCardImageHeight"
              :width="businessCardImageWidth"
              :alt="$t('message.avatar.default')"
              :src="source">
          </div>
        </slot>
      </div>
      <div class="d-flex flex-column pt-1 mt-2 w-100">
        <h5 class="text-left mb-3">
          {{ name }}<br/>
          <small
            v-if="relation"
            class="text-muted font-italic">
            {{ $t('message.businessCard.relation') }} {{ relation }}
          </small>
        </h5>
        <div
          v-if="userTitle"
          class="text-left">
          {{ userTitle }}
        </div>
        <div
          v-if="contractNumber"
          class="text-left">
          {{ contractNumber }}
        </div>
        <div
          v-if="createdAtFormatted"
          class="text-left">
          {{ createdAtFormatted }}
        </div>
        <div
          v-if="roles"
          class="text-left">
          {{ roles }}
        </div>
        <div
          v-if="dateOfBirthFormatted"
          class="text-left">
          {{ dateOfBirthFormatted }}
        </div>
        <div
          v-if="email"
          class="text-left">
          {{ email }}
        </div>
        <div
          v-if="phone"
          class="text-left">
          {{ phone }}
        </div>
        <br/>
        <div
          v-if="status"
          class="text-left">
          {{ $t('message.businessCard.status') }} {{ status }}
        </div>
        <div
          v-if="dateOfDeathFormatted"
          class="text-left">
          {{ $t('message.businessCard.deceased') }} {{ dateOfDeathFormatted }}
        </div>
      </div>
      <div
        v-if="showIcon">
        <span class="cross">&#8224;</span>
      </div>
    </div>
    <div class="text-left">
      <slot name="bcFooter">
      </slot>
    </div>
  </b-card>
</template>

<script>
  import UserIcon from 'ti-icons/SVG/user.svg'

  export default {
    props: {
      name: {
        type: String,
        required: true
      },
      relation: {
        type: String
      },
      contractNumber: {
        type: String
      },
      createdAt: {
        type: String
      },
      dateOfBirth: {
        type: String
      },
      dateOfDeath: {
        type: String
      },
      email: {
        type: String
      },
      phone: {
        type: String
      },
      roles: {
        type: String
      },
      status: {
        type: String
      },
      imageSrc: {
        type: String
      },
      size: {
        type: String
      },
      userTitle: {
        type: String
      },
      showIcon: {
        type: Boolean,
        default: false
      },
      variant: {
        type: String,
        default: function () {
          return 'bCardHover'
        }
      }
    },
    computed: {
      getStyle: function () {
        if (this.variant === 'noHover') {
          return {
            class: 'noHover'
          }
        } else {
          return {
            class: 'bCardHover'
          }
        }
      },
      businessCardStyle () {
        let styleClass = ''
        if (this.size && this.size === 'sm') {
          styleClass = 'business-card__sm'
        }
        styleClass = styleClass + ' ' + this.getStyle.class
        return styleClass
      },
      businessCardImageWidth () {
        if (this.size && this.size === 'sm') {
          return 100
        }
        return 150
      },
      businessCardImageHeight () {
        if (this.size && this.size === 'sm') {
          return 100
        }
        return 150
      },
      createdAtFormatted () {
        return this.createdAt ? this.$moment(this.createdAt, 'YYYY-MM-DD').format('DD.MM.YYYY') : null
      },
      dateOfBirthFormatted () {
        return this.dateOfBirth ? this.$moment(this.dateOfBirth, 'YYYY-MM-DD').format('DD.MM.YYYY') : null
      },
      dateOfDeathFormatted () {
        return this.dateOfDeath ? this.$moment(this.dateOfDeath, 'YYYY-MM-DD').format('DD.MM.YYYY') : null
      },
      source () {
        return this.imageSrc ? process.env.BACKEND_URL + 'avatars/' + this.imageSrc : UserIcon
      }
    }
  }
</script>

<style scoped>
  small {
    font-size: 70%;
  }

  .business-card__sm {
    font-size: 0.85rem;
  }

  .cross {
    line-height: 1;
    font-size: 600%;
  }

  div.bCardHover:hover{
    background-color: lightgray!important;
  }

  .circle {
    border: 1px solid #455a64;
  }

  .default-avatar {
    padding-left: 15%;
    padding-right: 15%;
    padding-bottom: 15%;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/BusinessCard.vue